class FormRouter {
    private form: HTMLElement;
    private activeRoute: string;

    /**
     * Creates an instance of FormRouter.
     * @param {HTMLElement} form - The form element to be managed by the router.
     */
    constructor(form: HTMLElement) {
        this.form = form;
        this.activeRoute = this.form.getAttribute('data-active-route') || '/';

        this.toggleElements();
        (window as any).updateActiveRoute = this.updateActiveRoute.bind(this);
    }

    /**
     * Toggles the visibility of elements based on the active route.
     * Elements with a matching `data-form-route` attribute will be displayed, others will be hidden.
     */
    private toggleElements(): void {
        document.querySelectorAll(`[data-form-id=${this.form.id}][data-form-route]`).forEach((element: Element) => {
            const route = element.getAttribute('data-form-route') || '';
            const visible = this.shouldBeVisible(route);

            visible
                ? delete (element as HTMLElement).dataset.display
                : (element as HTMLElement).dataset.display = 'none';
        });
    }

    /**
     * Determines if an element should be visible based on the current active route.
     * @param {string} route - The route to check against the active route.
     * @returns {boolean} - True if the element should be visible, false otherwise.
     */
    private shouldBeVisible(route: string): boolean {
        if (route === '/') return true;
        if (route === this.activeRoute) return true;
        if (route.includes('*')) {
            const regex = new RegExp('^' + route.replace('*', '.*') + '$');
            return regex.test(this.activeRoute);
        }
        return false;
    }

    /**
     * Updates the active route and toggles the visibility of elements accordingly.
     * @param {string} newRoute - The new route to set as active.
     */
    public updateActiveRoute(newRoute: string): void {
        this.activeRoute = newRoute;
        this.toggleElements();
    }
}

// Initialize FormRouter for each form with 'data-active-route' on page load.
window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('form[data-active-route]').forEach((formElement) => {
        new FormRouter(formElement as HTMLElement);
    });
});